class Emitter {
	

	constructor(all = Object.create(null)) {
		this.all = all;
	}

	/**
	 * Register an event handler for the given type.
	 *
	 * @param  {String} type    Type of event to listen for, or `"*"` for all events
	 * @param  {Function} handler Function to call in response to given event
	 */
	 on(type, handler) {
		(this.all[type] || (this.all[type] = [])).push(handler);
	}

	/**
	 * Remove an event handler for the given type.
	 *
	 * @param  {String} type    Type of event to unregister `handler` from, or `"*"`
	 * @param  {Function} handler Handler function to remove
	 */
	 off(type, handler) {
		if (this.all[type]) {
			this.all[type].splice(this.all[type].indexOf(handler) >>> 0, 1);
		}
	}

	/**
	 * Invoke all handlers for the given type.
	 * If present, `"*"` handlers are invoked after type-matched handlers.
	 *
	 * @param {String} type  The event type to invoke
	 * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
	 */
	 emit(type, evt) {
		(this.all[type] || []).slice().map(handler => handler(evt));
		(this.all['*'] || []).slice().map(handler => handler(type, evt));
	}
}

/**
 * Helps maintain the state of an application by storing key/value pairs with the option of listening to any updates
 * to the values.
 */

const STATE_CHANGE_EVENT = 'stateChangeEvent';

class State {

	 __init() {this.stateItems = {};}

	constructor() {State.prototype.__init.call(this);
		this.stateItems = {};
	}

	/**
	 * Add a new key/value set
	 * @param {string} key - A unique identifier
	 * @param {any} value - The initial value
	 */
	setValue(key, value) {
		if (!this.stateItems[key]) {
			this.stateItems[key] = new StateItem(value);
		} else {
			this.stateItems[key].value = value;
		}
		return this.stateItems[key].value;
	}

	/**
	 * Get the value of a key
	 * @param {string} key - A unique identifier
	 * @return {any} value associated with key
	 */
	getValue(key) {
		return this.stateItems[key] ? this.stateItems[key].value : null;
	}

	/**
	 * Listen to changes on a key
	 * @param {string} key - The key to listen to
	 * @return {Function} Handler to catch the change event
	 */
	on(key, callback) {
		if (!this.stateItems[key]) {
			this.stateItems[key] = new StateItem();
		}
		this.stateItems[key].on(STATE_CHANGE_EVENT, callback);
	}

	/**
	 * Stop listening to changes on a key
	 * @param {string} key - The key to listen to
	 * @return {Function} Handler to catch the change event
	 */
	off(key) {
		if (this.stateItems[key]) {
			this.stateItems[key].off(STATE_CHANGE_EVENT);
		}
	}
}

class StateItem extends Emitter {

	 __init2() {this._value = '';}

	constructor(value = '') {
		super();StateItem.prototype.__init2.call(this);		this.value = value;
	}

	get value() {
		return this._value;
	}

	set value(newValue) {
		const lastValue = this.value;
		this._value = newValue;
		this.emit(STATE_CHANGE_EVENT, {current: this.value, previous: lastValue});
	}
}

export default State;
